// File: assets/custom.js

// Using a robust self-executing function to ensure 'document' and 'window' are correctly scoped.
(function(window, document, undefined) {
  console.log('--- Custom Description Script Started (via Safe Wrapper) ---');

  // CONFIRMED ROBUST SELECTOR
  const descriptionSelector = '#ProductInformation-template--24741895995694__main > div > div.group-block-content.layout-panel-flex.layout-panel-flex--column > rte-formatter';


  // Function to process the description (moved out for reusability)
  function processDescription(container) {
    console.log('Attempting to process description:', container);

    let fullDescriptionHTML = ''; // Changed to HTML to preserve formatting
    let fullDescriptionTextForWordCount = ''; // Separate variable for word counting

    // Collect all direct block-level children that might contain description text
    const contentElements = container.querySelectorAll('p, ul, ol, h1, h2, h3, h4, h5, h6');

    if (contentElements.length === 0) {
      console.warn('No content tags (p, ul, ol, hx) found within the description container. Exiting function.');
      return;
    }

    contentElements.forEach(el => {
      fullDescriptionHTML += el.outerHTML; // Get outerHTML to preserve tags like <strong>, <em>, <li>
      fullDescriptionTextForWordCount += el.innerText.trim() + ' '; // Get innerText for accurate word counting
    });

    // Remove extra spaces and split into words for counting
    const words = fullDescriptionTextForWordCount.split(/\s+/).filter(word => word.length > 0);
    const wordLimit = 25;

    console.log('Total words in description (for truncation logic):', words.length);

    if (words.length > wordLimit) {
      console.log('Description length exceeds word limit (' + wordLimit + '). Truncating...');

      // --- CREATE SHORT DESCRIPTION ---
      const shortDescriptionWrapper = document.createElement('div');
      shortDescriptionWrapper.classList.add('short-description-wrapper');
      const shortText = words.slice(0, wordLimit).join(' ') + '...';
      const shortParagraph = document.createElement('p');
      shortParagraph.innerHTML = shortText;
      shortDescriptionWrapper.appendChild(shortParagraph);


      // --- CREATE FULL DESCRIPTION ---
      const fullDescriptionWrapper = document.createElement('div');
      fullDescriptionWrapper.classList.add('full-description-wrapper', 'hidden');
      fullDescriptionWrapper.innerHTML = fullDescriptionHTML;


      // --- CREATE READ MORE BUTTON ---
      const readMoreButton = document.createElement('button');
      readMoreButton.classList.add('read-more-button');
      readMoreButton.textContent = 'Read more'; // Initial text
      shortDescriptionWrapper.appendChild(readMoreButton);

      // --- REPLACE ORIGINAL CONTENT ---
      container.innerHTML = ''; // Clear existing content before appending new wrappers
      container.appendChild(shortDescriptionWrapper);
      container.appendChild(fullDescriptionWrapper);

      // Event listener for the "Read more" / "Show less" button
      readMoreButton.addEventListener('click', function() {
        console.log('Button clicked. Current text (before change attempt):', readMoreButton.textContent);
        console.log('Button element:', readMoreButton);

        if (fullDescriptionWrapper.classList.contains('hidden')) {
          console.log('--- Button State: Expanding ---');
          fullDescriptionWrapper.classList.remove('hidden');
          shortDescriptionWrapper.style.display = 'none';

          // Apply text change with a small delay to combat potential overwrites
          setTimeout(() => {
            readMoreButton.textContent = 'Show less';
            console.log('New button text (should be Show less, after delay):', readMoreButton.textContent);
          }, 10); // 10ms delay
        } else {
          console.log('--- Button State: Collapsing ---');
          fullDescriptionWrapper.classList.add('hidden');
          shortDescriptionWrapper.style.display = 'block';

          // Apply text change with a small delay to combat potential overwrites
          setTimeout(() => {
            readMoreButton.textContent = 'Read more';
            console.log('New button text (should be Read more, after delay):', readMoreButton.textContent);
          }, 10); // 10ms delay
        }
      });
    } else {
      console.log('Description is within word limit. No truncation needed.');
    }
  } // End of processDescription function


  // Listener for initial DOM load
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded fired.');
    const initialDescriptionContainer = document.querySelector(descriptionSelector);
    if (initialDescriptionContainer && !initialDescriptionContainer.dataset.processed) {
      console.log('Description container found on initial DOM load with new selector. Processing...');
      initialDescriptionContainer.dataset.processed = true;
      processDescription(initialDescriptionContainer);
    } else if (!initialDescriptionContainer) {
      console.error(`Description container NOT FOUND on DOMContentLoaded with selector: ${descriptionSelector}`);
      console.warn('The element was not found when DOMContentLoaded fired. Checking for asynchronous loading with MutationObserver.');
    }
  });


  // MutationObserver to handle dynamically loaded content
  const observer = new MutationObserver(function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) { // Element node
            if (node.matches(descriptionSelector) && !node.dataset.processed) {
              console.log('MutationObserver found description container directly added. Processing...');
              node.dataset.processed = true;
              processDescription(node);
              return;
            }
            const foundInside = node.querySelector(descriptionSelector);
            if (foundInside && !foundInside.dataset.processed) {
              console.log('MutationObserver found description container inside an added element. Processing...');
              foundInside.dataset.processed = true;
              processDescription(foundInside);
              return;
            }
          }
        }
      }
    }
  });

  // Start observing the body for changes in its children and their descendants.
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('--- Custom Description Script Setup Complete ---');

})(window, document); // Pass window and document explicitly